import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { SuperAcessoStruct } from '../../structs/usuario-admin/super-acesso.struct';

@Injectable({
  providedIn: 'root',
})
export class SuperAcessoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public validaSuperAcesso(tokenSuperAcesso: string): Observable<SuperAcessoStruct> {
    return this.httpClient
      .put<SuperAcessoStruct>(environment.urlApiUsuarioAdmin + `superAcesso/token/` + tokenSuperAcesso, {})
      .pipe(catchError(this.handleError));
  }
}
